import React from 'react';
import { ButtonField, Tooltip } from '@wk/components-v3-react16';
import { useResubmitOrchestrations } from '../useResubmitOrchestrations';

const ResubmitButton = () => {
  const {
    handleResubmitOrchestrations,
    canResubmitOrchestrations,
    isPending: isResubmitPending,
    resubmitTooltip,
  } = useResubmitOrchestrations();

  return (
    <ButtonField type="secondary">
      <button
        id="isResubmitPending"
        onClick={handleResubmitOrchestrations}
        disabled={!canResubmitOrchestrations || isResubmitPending}
      >
        {isResubmitPending ? 'Resubmitting...' : 'Resubmit'}
      </button>
      <Tooltip
        mode="description"
        targetSelector="#isResubmitPending"
        elementId="tooltip2"
      >
        {resubmitTooltip}
      </Tooltip>
    </ButtonField>
  );
};

export default ResubmitButton;
